<template>
  <div>
    <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" @close="closeDialog()" @visible-change="onVisible" title="" top="5vh" width="75%">
      <moduleForm
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :isForCurrentActiveUser="false"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          :showPasswordField="showPasswordField"
          class="p-3"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>


    <app-board style="border-radius: 0; padding: 5px; margin-bottom: 5px">
      <el-row>
        <el-col :span="12">
          Push List
        </el-col>
        <el-col :span="12" class="text-right">
          <el-button @click="createAction" icon="el-icon-plus" size="mini" type="primary">Create</el-button>
        </el-col>
      </el-row>
    </app-board>

    <app-board style="border-radius: 0;padding: 0;margin: 0;padding-top: 5px;">
      <div class="row m-0 p-0" style="height: 70px;">
      <div class="col-6 col-md-6 text-left">
          <small>Search</small>
          <dg-text-field
              :field_span="22"
              :label_span="22"
              :liveUpdate="true"
              @amUpdated="userSearchUpdated"
              class="m-0 p-0"
              field_mark=""
              placeholder="search username or display name"></dg-text-field>
        </div>
        <div class="col-6 col-md-6 mb-1 pt-4 text-right">
          <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
        </div>
      </div>
    </app-board>

    <!--    :default-sort="{prop: 'display_name', order: 'descending'}"-->
    <el-table
        :data="tableData"
        border
        cell-class-name="p-1"
        :row-class-name="tableRowClassName"
        style="width: 100%">
     
      <el-table-column
          label="Destination"
          prop="destination"
          sortable
          width="220">
      </el-table-column>
      <el-table-column
          label="Division"
          prop="division"
          width="160"
          sortable>
      </el-table-column>
      <el-table-column
          label="Prefix"
          prop="prefix"
          width="130"
          sortable>
      </el-table-column>
      <el-table-column
          label="Rate"
          prop="rate"
          width="160"
          sortable>
      </el-table-column>
      <el-table-column
          label="Note"
          prop="note"
          width="240">
      </el-table-column>
      <el-table-column
          label="Created at"
          prop="created_at"
          width="120">
      </el-table-column>
     
      <el-table-column
          
          label="Action"
          width="80"
          prop="">
        <template slot-scope="scope">
          <vDropdown :actionsHandler="actionsHandler" :items="usersActions" :params="{data: scope.row, rowIndex: scope.$index + 1} "
                     :userProfileId="currentUser"></vDropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import { getLS} from 'devegram-javascript-util';
// import voipCustomers from '../../../../modules/voip-customer/list/page/assign-customers'
import fieldController from "devegram-vue-data-collecter-eui/src/mixins/fieldController";
import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  mixins: [fieldController, panelMixin],
  components: {
   
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    vDropdown: () => import('./button-dropdown')
    
  },
  data() {
    return {
      currentUser : null,
      isUserSales: $store.getters['user-state/isUserSales'],
      customerData: null,
      resellerData : null,
      vendorData : null,
      cdrData : null,
      voipReportAnalysisStatisticRateDialog: false,
      editLiveTrafficRate: false,
      reportAnalysisStatisticViewMode: 'normal',
      showOnlyFixedRates: false,
      showOnlyNewRates: false,
      userUsingPrivateRate: null,
      userRateStatus: null,
      customerRatesBoardDialog: false,
      showCustomersList: false,
      showCustomersList2: false,
      showResellerList : false,
      showVendorList : false,
      showCDRList : false,
      selectedCustomerUsername: false,
      voipReportAnalysisStatisticDialog: false,
      topLcrDialogVisibility: false,
      usersActions: [
        {
          label: 'Edit',
          icon: 'el-icon-edit',
          action: 'editAction',
          borderBottom: true,
          
        },
       
        {
          label: 'Remove',
          icon: 'el-icon-delete',
          action: 'removeAction',
          
        },
        
        // {
        //   label: 'View CDR',
        //   icon: 'el-icon-delete',
        //   action: 'openCDRList',
        //   forProfiles: [6],
        // },
      ],
      tableData: [],
      control: this,
      profilesOptionsList: [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfiles],
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      showPasswordField: false,
      selectedUsername: ' - ',
      selectedUserId: null,
      setProfitRateDialogVisible: false,
      viewUserTestsDialogVisible: false,
      setWorkingRatesDialogVisible: false,
      currentPage: 1,
      pageChunkSize: 16,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      filterByProfileId: '',
      divisionsList: [],
      selectedUserProfileId: null,
      lcrSelectedDivision: false
    };
  },
  beforeMount() {
    
    if (this.isUserSales) {
      this.filterByProfileId = 6
    }
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
    this.panelMixin_getUserVoipDivision('divisionsList', () => {
    })
    this.currentUser = getLS('user').profile_id;
    this.profilesOptionsList = this.currentUser != 9 ? [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfiles] : [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfilesForManager]
    // debugger 
    
  },
  methods: {
    closeDialog(){
      // debugger
      this.showCustomersList2 =false;
      this.showResellerList = false;
      this.showVendorList = false;
      this.showCDRList = false;
      this.dialogVisible =  false;
    },
    onVisible(){
     this.showCustomersList2 =false;
     this.showResellerList = false;
     this.showVendorList = false;
     this.showCDRList = false;
     this.dialogVisible = false;
    },
    tableRowClassName({row, rowIndex}) {
      // if (row.email.substr(0,2) == '__') {
      //   return 'app-bg-gold-low-alfa';
      // }
      return '';
    },
    openCustomerRatesBoard (params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = false
      this.rowToEdit = -1
      this.customerData = data
      this.userRateStatus = (this.showOnlyNewRates) ? '<span class="app-bg-gold-low-alfa pending p-2">New Rates</span>' : '<span class="voip-call-test-status awaiting-action p-2">All</span>'
      this.userUsingPrivateRate = true
      this.editLiveTrafficRate = false
      this.customerRatesBoardDialog = true
    },
    openCustomersList (params){
       let data = params.data
    this.showCustomersList = true; 
    this.showCustomersList2 = true; 
    this.customerData = data
    },
    openResellerList(params){
      this.showResellerList = true;
      this.resellerData = params.data
    },
    openVendorList(params){
      this.showVendorList = true;
      this.vendorData = params.data
    },
    openCDRList(params){
      
      this.showCDRList = true;
      this.cdrData = params.data
    },
    viewReportAnalysisStatistic (params) {
      let data = params.data
      this.selectedCustomerUsername = data.username
      this.voipReportAnalysisStatisticDialog = true
      this.reportAnalysisStatisticViewMode = 'normal'
    },
    viewReportAnalysisStatisticRates (params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = false
      this.rowToEdit = -1
      this.customerData = data
      this.userRateStatus = '<span class="voip-call-test-status p-2">Live Traffic Rates</span>'
      this.userUsingPrivateRate = true
      this.editLiveTrafficRate = true
      this.voipReportAnalysisStatisticRateDialog = true
      // this.reportAnalysisStatisticViewMode = 'edit_live_traffic_rate'
    },
    lcrDialogClosed() {
      this.lcrSelectedDivision = false
    },
    lcrDivisionUpdated(inputField) {
      let selectedDivision = inputField.field.field_value

      this.lcrSelectedDivision = false
      $vue.nextTick(() => {
        this.lcrSelectedDivision = selectedDivision
      })
    },
    openTopLcrDestinationsDialog(params) {
      this.selectedUserId = params.data.id
      this.selectedUserProfileId = params.data.user_profile_id
      this.topLcrDialogVisibility = true
    },
    updateFusionField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.id,
        data
      }

      this.updateFusionEntity(apiParams).then(r => {
        afterSave()
      })
    },
    setTableFusionServerFormatter(row, column) {
      return $store.state['user-state'].usersFusionServers[row.id][column.property]
    },
    setTableVOSServerProp(id, property) {
      return $store.state['user-state'].usersVOSserver[id][property]
    },
    setTableFusionServerProp(id, property) {
      return $store.state['user-state'].usersFusionServers[id][property]
    },
    filterByProfileUpdated(inputField) {
      this.filterByProfileId = inputField.field.field_value
      this.getEntityListData(1)
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch, profileId: this.filterByProfileId}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.tableData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true
      
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions('user-state', {setStateUsers: 'setState'}),
    ...$mapActions('voip-testing-panel-api', {
      getUsersFusionServer: 'getUsersFusionServer',
    }),
    ...$mapActions(module.info.name + '-api', {
      getEntityList: 'list',
      getUsersVOSserver: 'getUsersVOSserver',
    }),
    ...$mapActions('voip-fusion-server-api', {updateFusionEntity: 'update'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.navigateToPage(this.currentPage)
    },
    afterEdit(updatedData) {
      $vue.set(this.tableData, this.rowToEdit, updatedData)
      this.dialogVisible = false;
      this.refreshGrid();
    },
    
    afterCreate(newEntity) {
      this.dialogVisible = false;
      this.refreshGrid();
    },
    
    createAction(params) {
      this.showPasswordField = true;
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
    },
    editAction(params) {
      this.showPasswordField = false
      this.editMode = true

      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      this.dialogVisible = true;
    },
    removeAction(params) {
      this.$confirm('This will permanently delete this user. Continue?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        
        this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
          // this.tableData.splice(params.rowIndex, 1);
          this.refreshGrid()
          this.recordsCounter -= 1;
          notify({
            type: 'success',
            title: this.$ml.get('deleted'),
          });
        })
      }).catch(() => {
      });
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>

<style>
.el-table__cell.el-table__expanded-cell {
  padding: 0;
}
</style>
